import { UsersRound, BarChart3, FileCheck2 } from 'lucide-react';
import { STATUTS_CP, dateFR } from './constantes';
import { BoutonsPV } from './PVValides';

const Chiffre = ({ valeur, label, testId, className = '' }) => (
  <div className={`rounded-xl bg-white/10 px-4 py-3 ${className}`}>
    <p className="truncate text-lg sm:text-2xl font-bold" data-testid={testId}>{valeur}</p>
    <p className="text-xs text-white/70">{label}</p>
  </div>
);

const COULEURS = { preparation: 'bg-white/15', convoque: 'bg-sky-400/30', tenu: 'bg-amber-400/30', cloture: 'bg-[#8DC63F]' };

export const EnteteConseil = ({ annee, annees, onAnnee, conseil, onBilan, onPdf }) => (
  <header className="rounded-2xl bg-[#334155] p-6 sm:p-8 text-white shadow-sm" data-testid="cp-entete">
    <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
      <div className="flex items-start gap-4">
        <div className="rounded-xl bg-white/15 p-3"><UsersRound className="h-7 w-7" /></div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-white/60">Administratif CFA</p>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Conseil de perfectionnement</h1>
          <p className="mt-2 max-w-2xl text-sm text-white/70">
            Un conseil par an (art. R.6231-4 du Code du travail). Les convocations, la feuille d'émargement et le procès-verbal validé
            sont rangés automatiquement dans le dossier Qualiopi (indicateur 30).
          </p>
        </div>
      </div>
      <div className="flex shrink-0 flex-wrap items-center gap-3">
        {conseil && (
          <button type="button" onClick={onBilan} data-testid="cp-bilan-entete"
            className="inline-flex items-center gap-2 rounded-full bg-[#8DC63F] px-4 py-2 text-sm font-semibold text-[#0F172A] transition-colors hover:bg-[#7DB52F]">
            <BarChart3 className="h-4 w-4" /> Bilan d'activité {annee}
          </button>
        )}
        <select value={annee} onChange={(e) => onAnnee(Number(e.target.value))} data-testid="cp-annee"
          className="rounded-full border border-white/20 bg-white/15 px-4 py-2 text-sm font-semibold text-white outline-none transition-colors hover:bg-white/25">
          {annees.map((a) => <option key={a} value={a} className="text-slate-900">{a}</option>)}
        </select>
        {conseil && (
          <span className={`rounded-full px-3 py-1.5 text-xs font-semibold ${COULEURS[conseil.statut]}`} data-testid="cp-statut">{STATUTS_CP[conseil.statut]}</span>
        )}
      </div>
    </div>
    {conseil && (
      <div className="mt-6 grid grid-cols-2 gap-3 sm:max-w-xl sm:grid-cols-3">
        <Chiffre valeur={conseil.date ? dateFR(conseil.date) : '—'} label="Date de la séance" testId="cp-chiffre-date" className="col-span-2 sm:col-span-1" />
        <Chiffre valeur={conseil.participants.length} label="Participants" testId="cp-chiffre-participants" />
        <Chiffre valeur={conseil.ordre_du_jour.length} label="Points à l'ordre du jour" testId="cp-chiffre-points" />
      </div>
    )}
    {conseil?.valide_le && (
      <div className="mt-5 flex flex-wrap items-center gap-3 rounded-xl bg-white/10 px-4 py-3" data-testid="cp-pv-entete">
        <p className="flex items-center gap-2 text-sm font-medium"><FileCheck2 className="h-4 w-4 text-[#8DC63F]" /> Compte rendu validé le {dateFR(conseil.valide_le)}</p>
        <BoutonsPV annee={annee} onPdf={onPdf} clair prefixe="cp-pv-entete" />
      </div>
    )}
  </header>
);
